module.exports = __webpack_public_path__ + "static/media/10.0d4c3afa.png";